/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDesktopTower: {
  name: 'desktop-tower';
  data: string;
} = {
  name: 'desktop-tower',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 .5A1.5 1.5 0 0 0 2.5 2v12A1.5 1.5 0 0 0 4 15.5h8a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 12 .5H4ZM3.5 14V8.5h9V14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5Zm0-6.5h9v-3h-9v3Zm9-4V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v1.5h9Zm-1 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
